module.exports = __webpack_public_path__ + "img/sceneIcon1-3.bbdcb435.png";